var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-row',{attrs:{"justify":"center","align":"center"}},[_c('v-col',{attrs:{"cols":"8"}},[_c('UserBalance',{attrs:{"user":_vm.$store.state.user}})],1),_c('v-col',{attrs:{"cols":"4"}},[_c('BuyTokens',{attrs:{"user":_vm.$store.state.user}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }